export default __webpack_public_path__ + "static/media/Minicard_9h.a2f6e645.svg";